import { withStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@mui/styles"
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AppBar,
  Box,
  FormControl,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Toolbar,
  Typography,
  styled,
  useRadioGroup,
  Grid,
  Button,
  FormLabel
} from "@mui/material";
import Fade from '@mui/material/Fade';
import {
  useGridApiRef,
} from "@mui/x-data-grid-premium";
import _ from "lodash";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import ColorConstants from "../../../../defaults/ColorConstants";
import FieldNames from "../../../../defaults/FieldNames.json";
import TargetBarChart from "./TargetBarChart";
import PaginationLink from './TargetManagementDialogPagination';
import WorkflowFiscalYearFilter from "./WorkflowFiscalYearFilter";
import WorkflowGridFilters from "./WorkflowGridFilters";
import {calculateFiscalYearQuarter, formatDateForDisplay} from "../../../../utils/DateHelper";
import TargetManagementPostFire from "./TargetManagementPostFire";
import TargetManagementFuels from "./TargetManagementFuels";
import { emitCustomEvent } from "react-custom-events";
import Events from "../../../../defaults/Events";
import ErrorService from "../../../../services/ErrorService";
import { useIFPRSGlobalContext } from "../../../../IFPRSGlobalContext";
import { getSummaryFundingRowsForProgramOfWork } from "../../../../utils/FeatureHelper";
import { generateFeatureDataPromise } from "../../../../utils/DownloadHelper";
import * as XLSX from 'xlsx/xlsx.mjs';
import FileSaver from 'file-saver';
import TargetAccomplishmentService from "../../../../services/TargetAccomplishmentService";


const StyledFormControlLabel = styled((props) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  ".MuiFormControlLabel-label": {
    // Change color here
    color: ColorConstants.WhiteAlien
  },
  ".MuiFormControlLabel": {
    // Change color here
    color: ColorConstants.WhiteAlien
  }
}));

function HeaderFormControlLabel(props) {
  // MUI UseRadio Group
  const radioGroup = useRadioGroup();

  let checked = false;
  let disabled = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
    disabled = true;
  }

  return <StyledFormControlLabel checked={checked} disabled={disabled} {...props} />;
}

const HeaderRadio = withStyles({
  root: {
    color: ColorConstants.WhiteAlien,
    "&$disabled": {
      color: ColorConstants.GrayAlien,
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);


function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  const finalWidth = width - 20;
  return {
    finalWidth,
    height
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}


export default function TargetManagementDialog({
  currentUserInfo,
  userRoleInfo,
  setShowMap,
  headerheight
}) {
  const navigate = useNavigate();
  const config = useSelector((state) => state.configuration.config);
  const rootServiceUrl = useSelector(
    (state) => state.configuration.rootServiceUrl
  );
  const useStyles = makeStyles({
    underline: {
      "&&&:before": {
        borderBottom: "2px solid red",
      },
      "&&:after": {
        borderBottom: "2px solid red",
      },
    },
    condensedFormControl: {
      margin: "5px 15px 5px 15px",
      minWidth: 120,
      width: "90%",
    },
    formControl: {
      margin: "10px 15px 10px 15px",
      minWidth: 120,
      width: "90%",
    },
    formControlHeader: {
      margin: "0px 15px 0px 15px",
      minWidth: 120,
      width: "90%",
    },
    snackBarStyle: {
      top: "120px !important",
    },
  });
  const classes = useStyles();
  const { height } = useWindowDimensions();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isFailure, setIsFailure] = useState(false);
  const [graphRows, setGraphRows] = useState([]);
  const [maxCountPerGraph] = useState(25);
  const [limitedGraphRows, setLimitedGraphRows] = useState([]);
  const [classOptionSelection, setClassOptionSelection] = useState(FieldNames.targetOptions.treatments);
  const [gridRadioValue, setGridRadioValue] = useState("Default");

  const theme = createTheme({
    overrides: {
      palette: {
        red: {
          main: "#FF0000",
          light: "#FF0000",
          dark: "#FF0000",
          contrastText: "#242105",
        },
      },
      MuiPaper: {
        root: {
          backgroundColor: "green",
        },
      },
      MuiOutlinedInput: {
        root: {
          "& $notchedOutline": {
            //initial border
            borderColor: ColorConstants.BlueAlien,
          },
          "&:hover $notchedOutline": {
            //border on hover
            borderColor: ColorConstants.BlueAlien,
            border: "2px solid",
          },
          "&$focused $notchedOutline": {
            //border on focus
            borderColor: ColorConstants.BlueAlien,
            border: "2px solid",
          },
        },
      },
    },
  });

  const [fundingDepartmentSelection, setFundingDepartmentSelection] =
    useState(null);
  const [fundingAgencySelection, setFundingAgencySelection] = useState(null);
  const [fundingRegionSelection, setFundingRegionSelection] = useState(null);
  const [fundingUnitSelection, setFundingUnitSelection] = useState(null);
  const [fundingSubUnitSelection, setFundingSubUnitSelection] = useState(null);
  const [fundingTribeSelection, setFundingTribeSelection] = useState(null);
  const [entityTypeSelection, setEntityTypeSelection] = useState(null);
  

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    SubUnit: false,
    Tribe: false,
  });
  
  const currLevelLabel =
    fundingTribeSelection &&
    fundingTribeSelection[FieldNames.targetFields.tribe]
      ? "Tribe"
      : fundingSubUnitSelection &&
        fundingSubUnitSelection[FieldNames.targetFields.subUnit]
      ? "SubUnit"
      : fundingUnitSelection &&
        fundingUnitSelection[FieldNames.targetFields.unit]
      ? "Unit"
      : fundingRegionSelection &&
        fundingRegionSelection[FieldNames.targetFields.region]
      ? "Region"
      : fundingAgencySelection &&
        fundingAgencySelection[FieldNames.targetFields.agency]
      ? "Agency"
      : fundingDepartmentSelection &&
        fundingDepartmentSelection[FieldNames.targetFields.department]
      ? "Department"
      : "";
  const currentSelectedLevel =
    currLevelLabel === "Department"
      ? fundingDepartmentSelection[FieldNames.targetFields.department]
      : currLevelLabel === "Agency"
      ? fundingAgencySelection[FieldNames.targetFields.agency]
      : currLevelLabel === "Region"
      ? fundingRegionSelection[FieldNames.targetFields.region]
      : currLevelLabel === "Unit"
      ? fundingUnitSelection[FieldNames.targetFields.unit]
      : currLevelLabel === "SubUnit"
      ? fundingSubUnitSelection[FieldNames.targetFields.subUnit]
      : currLevelLabel === "Tribe"
      ? fundingTribeSelection[FieldNames.targetFields.tribe]
      : "Master Level";

  const [fiscalYearSelection, setFiscalYearSelection] = useState(null);
  const [fiscalYearOptions, setFiscalYearOptions] = useState([]);
  const fiscalYearFileName = fiscalYearSelection?.FiscalYear ? `FY${fiscalYearSelection.FiscalYear}POW` : null
  const [isTreatment, setIsTreatment] = useState(true);
  const [existingLockDate, setExistingLockDate] = useState(null);
  const [powFileDate, setPowFileDate] = useState(null);
  //const doesPowFileExist = powFileDate != null;
  const [doesPowFileExist, setDoesPowFileExist] = useState(false);
  const { setShowGlobalLoader} = useIFPRSGlobalContext();

  // Calculated Budget Values
  const [gridExpanded, setGridExpanded] = useState(true);
  const handleGridChange = () => {
    setGridExpanded(!gridExpanded);
  };
  const [graphExpanded, setGraphExpanded] = useState(false);
  const handleGraphChange = () => {
    setGraphExpanded(!graphExpanded);
  };

  useEffect(() => {
    setShowMap(false);
  }, [setShowMap]);

  useEffect(() => {
    let fyList = [];
    let currFY = calculateFiscalYearQuarter(new Date(), true);
    let earliestYear = 2024;
    if (currFY) {
      while ( earliestYear <= currFY ) {
        fyList.push(earliestYear++);
      }   
    }

    fyList = fyList.map((year) => {
      return { FiscalYear: `${year}` };
    });
    setFiscalYearOptions(fyList);
    setFiscalYearSelection({ FiscalYear: `${currFY}` });
  }, [config, rootServiceUrl]);

  useEffect(() => {
    const fetchData = async () => {
      try
      {
        if(fiscalYearSelection?.FiscalYear)
        {
          const doesFileExist = await TargetAccomplishmentService.checkProgramOfWorkFileExistence(fiscalYearFileName);
          setDoesPowFileExist(doesFileExist);
        }
        else
        {
          setDoesPowFileExist(false);
        }
      }
      catch(e)
      {
        setDoesPowFileExist(false);
        if(!(e?.response?.status) || e?.response?.status !== 404)
        {
          throw e;
        }
      }
    }

    fetchData().catch((e) => ErrorService.addErrorLogEntry(currentUserInfo[FieldNames.userFields.nifcUsername], e));

  }, [fiscalYearSelection?.FiscalYear])

  //
  // General Page Methods
  //

  const handleClose = () => {
    setShowMap(true);
    navigate("/home");
  };

  // --- Grid Logic ---


  const getLabel = () => {
    const departmentExists = fundingDepartmentSelection && fundingDepartmentSelection[FieldNames.targetFields.filterDepartment];
    const agencyExists = fundingAgencySelection && fundingAgencySelection[FieldNames.targetFields.filterAgency];
    const regionExists = fundingRegionSelection && fundingRegionSelection[FieldNames.targetFields.filterRegion];
    const unitExists = fundingUnitSelection && fundingUnitSelection[FieldNames.targetFields.filterUnit];
    let label = "";
    if(agencyExists === FieldNames.agencies.bia){
      label = !departmentExists
      ? FieldNames.targetFields.filterDepartment
      : !agencyExists
      ? FieldNames.targetFields.filterAgency
      : !regionExists
      ? FieldNames.targetFields.filterRegion
      : !unitExists
      ? FieldNames.targetFields.filterUnit
      : FieldNames.targetFields.filterTribe;
    } else if(agencyExists === FieldNames.agencies.blm){
      label = !departmentExists
      ? FieldNames.targetFields.filterDepartment
      : !agencyExists
      ? FieldNames.targetFields.filterAgency
      : !regionExists
      ? FieldNames.targetFields.filterRegion
      : !unitExists
      ? FieldNames.targetFields.filterUnit
      : FieldNames.targetFields.filterSubUnit;
    } else {
      label = !departmentExists
      ? FieldNames.targetFields.filterDepartment
      : !agencyExists
      ? FieldNames.targetFields.filterAgency
      : !regionExists
      ? FieldNames.targetFields.filterRegion
      : FieldNames.targetFields.filterUnit
    }
    
    return label;
  }

  const generateProgramOfWorkCSV = async (isPreview) =>
  {
    try
    {
      setShowGlobalLoader(true);
      const allActionFundingRows = await getSummaryFundingRowsForProgramOfWork(fiscalYearSelection);
      if(allActionFundingRows?.length > 0)
      {
        const dataRows = await generateFeatureDataPromise(allActionFundingRows);
        if(dataRows)
        {
          let featureSheet = XLSX.utils.aoa_to_sheet(dataRows);
          let csvData = XLSX.utils.sheet_to_csv(featureSheet);
          if(isPreview)
          {
            // Handle any necessary metadata logging for the preview file
          }
          TargetAccomplishmentService.uploadProgramOfWorkCSV(csvData, fiscalYearFileName)
        }
        else
        {
          throw new Error("Failed to generate data rows for program of work download")
        }
      }
      else
      {
        throw new Error("Failed to query Actions for program of work download")
      }
    }
    catch(e)
    {
      ErrorService.addErrorLogEntry(currentUserInfo[FieldNames.userFields.nifcUsername], e);
    }
    finally
    {
      setShowGlobalLoader(false);
    }
  }

  const downloadProgramOfWorkCSV = async () => {
    try
    {
      setShowGlobalLoader(true);
      let resp = await TargetAccomplishmentService.downloadProgramOfWorkCSV(fiscalYearFileName);
    }
    catch(e)
    {
      if(e?.response?.status === 404)
      {
        // File does not exist for this Fiscal Year
        setSnackbarOpen(true);
        setSnackbarMessage(`Unable to find program of work file for Fiscal Year ${fiscalYearSelection?.FiscalYear}`);
        setIsFailure(true);
      }
      else
      {
        ErrorService.addErrorLogEntry(currentUserInfo[FieldNames.userFields.nifcUsername], e);
      }
    }
    finally
    {
      setShowGlobalLoader(false);
    }
  }

  return (
    <div style={{ height: height, overflow: 'scroll', backgroundColor: ColorConstants.MidGray}}>
      <AppBar
        sx={{ position: "relative" }}
        style={{ backgroundColor: ColorConstants.BlueAlien, marginTop: headerheight }}
      >
        <Toolbar>
          <FormControl variant="standard" className={classes.formControl}>
            <ThemeProvider theme={theme}>
              <Grid
                item
                size={12}
                
                container
                direction="row"
                className="grid-item"
                style={{ alignItems: "center" }}
              >
                <Grid item size={0.2}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                  >
                    <CloseIcon style={{ fill: ColorConstants.WhiteAlien }} />
                  </IconButton>
                </Grid>
                <Grid item size={4}>
                  <Typography
                    sx={{ ml: 2, flex: 1 }}
                    variant="h6"
                    component="div"
                    style={{ color: ColorConstants.WhiteAlien }}
                  >
                    Targets & Accomplishments
                  </Typography>
                </Grid>
                
                <WorkflowFiscalYearFilter
                  fiscalYearSelection={fiscalYearSelection}
                  setFiscalYearSelection={setFiscalYearSelection}
                  fiscalYearOptions={fiscalYearOptions}
                />
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={classOptionSelection}
                  sx={{display: 'inline', color: ColorConstants.WhiteAlien, marginLeft: 10}}
                  name="radio-buttons-group"
                  onChange={(event) => {
                    // if(entityTypeSelection === FieldNames.datasets.postfire){
                    //   if(event.target.value === FieldNames.targetOptions.treatments){
                    //     setIsTreatment(true);
                    //   } else {
                    //     setIsTreatment(false)
                    //   }
                    //   setClassOptionSelection(event.target.value);
                    // } 
                  }}
                >
                  <HeaderFormControlLabel value={FieldNames.targetOptions.treatments} control={<HeaderRadio />} label={FieldNames.targetOptions.treatments} entityTypeSelection={entityTypeSelection} />
                  <HeaderFormControlLabel value={FieldNames.targetOptions.activities} control={<HeaderRadio />} label={FieldNames.targetOptions.activities} entityTypeSelection={entityTypeSelection} />
                </RadioGroup>
              </Grid>
            </ThemeProvider>
          </FormControl>
        </Toolbar>
      </AppBar>
      <Paper>
        <Box
          sx={{
            height: currentSelectedLevel === "Master Level" ? "250px" : 
                    (fundingAgencySelection && fundingAgencySelection[FieldNames.targetFields.agency] &&
                      (fundingAgencySelection[FieldNames.targetFields.agency] === FieldNames.agencies.blm ||
                      fundingAgencySelection[FieldNames.targetFields.agency] === FieldNames.agencies.bia)
                     ? "425px" : "375"),
            width: "100%",
            minWidth: "10px",
          }}
        >
          <WorkflowGridFilters
            currentUserInfo={currentUserInfo}
            userRoleInfo={userRoleInfo}
            fundingDepartmentSelection={fundingDepartmentSelection}
            setFundingDepartmentSelection={setFundingDepartmentSelection}
            fundingAgencySelection={fundingAgencySelection}
            setFundingAgencySelection={setFundingAgencySelection}
            fundingRegionSelection={fundingRegionSelection}
            setFundingRegionSelection={setFundingRegionSelection}
            fundingUnitSelection={fundingUnitSelection}
            setFundingUnitSelection={setFundingUnitSelection}
            fundingSubUnitSelection={fundingSubUnitSelection}
            setFundingSubUnitSelection={setFundingSubUnitSelection}
            fundingTribeSelection={fundingTribeSelection}
            setFundingTribeSelection={setFundingTribeSelection}
            entityTypeSelection={entityTypeSelection}
            setEntityTypeSelection={setEntityTypeSelection}
            setColumnVisibilityModel={setColumnVisibilityModel}
            setIsTreatment={setIsTreatment}
            setClassOptionSelection={setClassOptionSelection}
          />
        </Box>
        { entityTypeSelection === FieldNames.datasets.fuels &&
          <>
            { currentUserInfo?.[FieldNames.userFields.isProgramOfWorkAdmin] &&
              <Grid item size={12} container direction="row" className="grid-item" style={{ alignItems: 'center', marginTop: "10px" }}>
                <Grid item size={1.5}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      generateProgramOfWorkCSV(true)
                    }}
                    aria-label="cancel"
                    sx={{marginLeft: "10px"}}
                  >
                    Generate Preview
                  </Button>
                </Grid>
                <Grid item size={1}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      emitCustomEvent(Events.LockProgramOfWork);
                    }}
                    aria-label="cancel"
                  >
                    Lock POW
                  </Button>
                </Grid>
                <Grid item size={9.5}>
                  {existingLockDate && 
                  <span>
                    APOW was locked on {formatDateForDisplay(existingLockDate)}
                  </span>
                  }
                </Grid>
              </Grid>
            }
            {
              (doesPowFileExist || existingLockDate) && 
              <Grid item size={12} container direction="row" className="grid-item" style={{ alignItems: 'center' }} sx={{marginTop: "10px"}}>
                <Grid item size={1.5}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      downloadProgramOfWorkCSV();
                    }}
                    aria-label="cancel"
                    sx={{marginLeft: "10px"}}
                  >
                    Download APOW
                  </Button>
                </Grid>
                <Grid item size={9.5}>
                  {doesPowFileExist && !existingLockDate && 
                    <span>
                      Preliminary Program of Work file was generated {formatDateForDisplay(powFileDate)}
                    </span>
                  }
                  {
                    existingLockDate &&
                    <span>
                     Annual Program of Work for FY{fiscalYearSelection?.FiscalYear} was locked {formatDateForDisplay(existingLockDate)}
                    </span>
                  }
                </Grid>
              </Grid>
            }
          </>
        }
        <Paper
        style={{
          backgroundColor: ColorConstants.MidGray,
          height: '100%',
          // overflow: 'auto',
          // minHeight: '100vh',
          marginTop: 20,
        }}
      >
        <div
          sx={{
            height: '100%',
            minWidth: "10px",
            marginBottom: 10,
            backgroundColor: ColorConstants.MidGray,
          }}
        >
          <Accordion
            expanded={gridExpanded}
            style={{ backgroundColor: ColorConstants.LightGrayAlien }}
            slots={{ transition: Fade }}
            slotProps={{ transition: { timeout: 400 } }}
            sx={[
              gridExpanded
                ? {
                    '& .MuiAccordion-region': {
                      height: 'auto',
                    },
                    '& .MuiAccordionDetails-root': {
                      display: 'block',
                    },
                  }
                : {
                    '& .MuiAccordion-region': {
                      height: 0,
                    },
                    '& .MuiAccordionDetails-root': {
                      display: 'none',
                    },
                  },
            ]}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panelGrid-content"
              id="panelGrid-header"
              onClick={() => {
                handleGridChange();
              }}
            >
              <Grid container spacing={2} sx={{width:'75%'}}>
                <Grid size={4}>
                  <Typography variant="h5">{getLabel()}</Typography>
                </Grid>
                {(entityTypeSelection === FieldNames.datasets.fuels && classOptionSelection === FieldNames.targetOptions.treatments) &&
                  <Grid size={8}>
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={gridRadioValue}
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          if(event.target.value)
                          {
                            setGridRadioValue(event.target.value);
                          }
                        }}
                        row
                      >
                        <FormControlLabel value="Default" control={<Radio />} label="Default" />
                        <FormControlLabel value="Funding" control={<Radio />} label="Funding" />
                        <FormControlLabel value="Carryover" control={<Radio />} label="Carryover" />
                        <FormControlLabel value="All" control={<Radio />} label="All" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                }
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
            <Box>
              <Paper sx={{marginBottom: '5px', marginLeft: '5px'}}>
                {(entityTypeSelection === FieldNames.datasets.postfire) &&
                  <TargetManagementPostFire 
                    setColumnVisibilityModel={setColumnVisibilityModel} 
                    setShowMap={setShowMap} 
                    currentUserInfo={currentUserInfo} 
                    classOptionSelection={classOptionSelection} 
                    columnVisibilityModel={columnVisibilityModel} 
                    setGraphRows={setGraphRows}
                    setLimitedGraphRows={setLimitedGraphRows}
                    fundingDepartmentSelection={fundingDepartmentSelection}
                    fundingAgencySelection={fundingAgencySelection}
                    fundingRegionSelection={fundingRegionSelection}
                    fundingUnitSelection={fundingUnitSelection}
                    fundingSubUnitSelection={fundingSubUnitSelection}
                    fundingTribeSelection={fundingTribeSelection}
                    entityTypeSelection={entityTypeSelection}
                    fiscalYearSelection={fiscalYearSelection}
                  />
                }
                {(entityTypeSelection === FieldNames.datasets.fuels && classOptionSelection === FieldNames.targetOptions.treatments) &&
                  <TargetManagementFuels
                    setColumnVisibilityModel={setColumnVisibilityModel} 
                    setShowMap={setShowMap} 
                    currentUserInfo={currentUserInfo} 
                    classOptionSelection={classOptionSelection} 
                    columnVisibilityModel={columnVisibilityModel} 
                    setGraphRows={setGraphRows}
                    setLimitedGraphRows={setLimitedGraphRows}
                    fundingDepartmentSelection={fundingDepartmentSelection}
                    fundingAgencySelection={fundingAgencySelection}
                    fundingRegionSelection={fundingRegionSelection}
                    fundingUnitSelection={fundingUnitSelection}
                    fundingSubUnitSelection={fundingSubUnitSelection}
                    fundingTribeSelection={fundingTribeSelection}
                    entityTypeSelection={entityTypeSelection}
                    fiscalYearSelection={fiscalYearSelection}
                    userInfo={currentUserInfo}
                    setExistingLockDate={setExistingLockDate}
                    generateProgramOfWorkCSV={generateProgramOfWorkCSV}
                    gridRadioValue={gridRadioValue}
                  />
                }
              </Paper>
              </Box>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={graphExpanded}
            style={{ backgroundColor: ColorConstants.LightGrayAlien }}
            slots={{ transition: Fade }}
            slotProps={{ transition: { timeout: 400 } }}
            sx={[
              graphExpanded
                ? {
                    '& .MuiAccordion-region': {
                      height: 'auto',
                    },
                    '& .MuiAccordionDetails-root': {
                      display: 'block',
                    },
                  }
                : {
                    '& .MuiAccordion-region': {
                      height: 0,
                    },
                    '& .MuiAccordionDetails-root': {
                      display: 'none',
                    },
                  },
            ]}
          >
          <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panelGraph-content"
              id="panelGraph-header"
              onClick={() => {
                handleGraphChange();
              }}
            >
              <Typography variant="h5">Graph</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div>
                {graphExpanded &&
                  <Fragment>
                    <TargetBarChart gridRows={limitedGraphRows} getLabel={getLabel} entityTypeSelection={entityTypeSelection} />
                    <PaginationLink items={graphRows} limitedGraphRows={limitedGraphRows} setLimitedGraphRows={setLimitedGraphRows} maxCountPerGraph={maxCountPerGraph} />
                  </Fragment>
                }
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
        <Box>
          <ThemeProvider theme={theme}>
            <Snackbar
              open={snackbarOpen}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              className={classes.snackBarStyle}
              onClose={() => {
                setSnackbarOpen(false);
                setSnackbarMessage("");
              }}
              sx={{zIndex: 9999}}
            >
              <Alert
                onClose={() => {
                  setSnackbarOpen(false);
                  setSnackbarMessage("");
                }}
                severity={isFailure ? "error" : "success"}
                sx={{ width: "100%" }}
              >
                {snackbarMessage}
              </Alert>
            </Snackbar>
          </ThemeProvider>
        </Box>
      </Paper>



        
      </Paper>
    </div>
  );
}